 import dayjs from 'dayjs';
import {
  OrganizationSubmission, FilemakerCreateOrganization, ContactSubmission, FilemakerCreateContact, ProjectSubmission,
 } from '../models';
import { FilemakerCreateProject } from '../models/filemakerSubmissions/FilemakerCreateProject.model';

 export const mapOrganizationSubmissionToFileMakerCreateOrganization = (submission: OrganizationSubmission): FilemakerCreateOrganization => ({
  'Organization ID': submission.filemakerOrganizationId,
  'Organization Name': submission.name,
  'Address Line1': submission.addressLine1,
  'Address Line2': submission.addressLine2,
  'Address State': submission.state,
  'Address City': submission.city,
   'Address Zip': submission.zip,
   'Address Country': submission.country,
   Phone: submission.phone,
   'Phone Fax': submission.fax,
   WebsiteURL: submission.websiteUrl,
   'Organization Email Address': submission.email,
 });

 export const mapFileMakerCreateOrganizationToSafeQuery = (submission: FilemakerCreateOrganization): FilemakerCreateOrganization => ({
  'Organization Name': submission['Organization Name'] ? `*${submission['Organization Name']}*` : '',
  'Address Line1': submission['Address Line1'] ? `*${submission['Address Line1']}*` : '',
  'Address Line2': submission['Address Line2'] ? `*${submission['Address Line2']}*` : '',
  'Address State': submission['Address State'] ? `*${submission['Address State']}*` : '',
  'Address City': submission['Address City'] ? `*${submission['Address City']}*` : '',
   'Address Zip': submission['Address Zip'] ? `*${submission['Address Zip']}*` : '',
   'Address Country': submission['Address Country'] ? `*${submission['Address Country']}*` : '',
 });

 export const mapFileMakerCreateContactToSafeQuery = (submission: FilemakerCreateContact): FilemakerCreateContact => ({
  'Name First Name': submission['Name First Name'] ? `*${submission['Name First Name']}*` : '',
  'Name Last Name': submission['Name Last Name'] ? `*${submission['Name Last Name']}*` : '',
  'Job Title': submission['Job Title'] ? `*${submission['Job Title']}*` : '',
  'Organization ID': submission['Organization ID'] ? `*${submission['Organization ID']}*` : '',
 });

 export const mapContactSubmissionToFileMakerCreateContact = (submission: ContactSubmission, organizationId: string, isLiason: boolean = false, isBillingContact: boolean = false): FilemakerCreateContact => ({
  'Name First Name': submission.firstName,
  'Name Last Name': submission.lastName,
  'Member Type': submission.memberType,
  'Job Title': submission.jobTitle,
  Email: submission.email,
  Phone: submission.phone,
  'Phone Fax': submission.fax,
  'Contact ID': submission.filemakerContactId,
  'Organization ID': organizationId,
  'QCP liaison': isLiason ? '1' : null,
  'Billing Contact': isBillingContact ? '1' : null,
 });

 export const mapProjectSubmissionToFileMakerCreateProject = (submission: ProjectSubmission): FilemakerCreateProject => ({
  'PR Name': submission.name,
  'QCP Project Number Calc': submission.number,
  'PR City': submission.city,
  ProjectType: submission.type,
  'PR St': submission.stateProvince,
  'PR Country': submission.country,
  'Referenced Standard': submission.standards,
  'PR Status': submission.status,
  'Project Phase at time of Registration': submission.statusAtRegistration,
  'Date Specs Confirmed': submission.estimatedShopDrawingStartDate ? dayjs(submission.estimatedShopDrawingStartDate).format('MM/DD/YYYY') : '',
  'Estimated Completion Date of Project': submission.estimatedCompletionDate ? dayjs(submission.estimatedCompletionDate).format('MM/DD/YYYY') : '',
  'WW scope in contract': submission.scope,
 });

 export default {
   mapOrganizationSubmissionToFileMakerCreateOrganization,
   mapContactSubmissionToFileMakerCreateContact,
   mapProjectSubmissionToFileMakerCreateProject,
   mapFileMakerCreateOrganizationToSafeQuery,
 };